//The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill';
import 'eventsource-polyfill';
import Vue from "vue";
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";
//template and route
import Mobiscope from "./Mobiscope";
import mobiscope from "./router/mobiscope";
import Mobizone from "./Mobizone";
import mobizone from "./router/mobizone";
import Games4all from "./Games4all";
import games4all from "./router/games4all";
import Mobiflix from "./Mobiflix";
import mobiflix from "./router/mobiflix";
import Miximo from "./Miximo";
import miximo from "./router/miximo";
import Gameknight from "./Gameknight";
import gameknight from "./router/gameknight";
import Gameonz from "./Gameonz";
import gameonz from "./router/gameonz";
import FunPlus from "./FunPlus";
import funplus from "./router/funplus";
import GameBox from "./GameBox";
import gamebox from "./router/gamebox";
import Prizeo from "./Prizeo";
import prizeo from "./router/prizeo";
import Fun2win from "./Fun2win";
import fun2win from "./router/fun2win";
import Cutemobi from "./Cutemobi";
import cutemobi from "./router/cutemobi";
import Cutehub from "./Cutehub";
import cutehub from "./router/cutehub";
import Apps4all from "./Apps4all";
import apps4all from "./router/apps4all";
import Playmix from "./Playmix";
import playmix from "./router/playmix";

import HelloWorld from "./HelloWorld.vue";

//locales or translate use i18n
//i18n is for locales translate
import i18n_Mz from "./i18n/mobizone/i18n";
import i18n_Ms from "./i18n/mobiscope/i18n";
import i18n_G4all from "./i18n/games4all/i18n";
import i18n_Mf from "./i18n/mobiflix/i18n";
import i18n_Mix from "./i18n/miximo/i18n";
import i18n_Gkn from "./i18n/gameknight/i18n";
import i18n_Gonz from "./i18n/gameonz/i18n";
import i18n_FunP from "./i18n/funplus/i18n";
import i18n_gamebox from "./i18n/gamebox/i18n";
import i18n_prizeo from "./i18n/prizeo/i18n";
import i18n_F2w from "./i18n/fun2win/i18n";
import i18n_cm from "./i18n/cutemobi/i18n";
import i18n_cutehub from "./i18n/cutehub/i18n";
import i18n_a4all from "./i18n/apps4all/i18n";
import i18n_Pm from "./i18n/playmix/i18n";

//others
import VueResource from "vue-resource";
import axios from "axios";
import store from "./store/index";

const proxyurl = "https://cors-anywhere.herokuapp.com/";

//default url for login
axios.defaults.baseURL = `${proxyurl}http://cook.gateway.puretechglobal.net/gateway_request/api/sub/`;

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(VuePlyr);

const host = window.location.host;
let template = "";

if (host.includes("mobizone")) {
  template = "Mobizone";
} else if (host.includes("mobiscope")) {
  template = "Mobiscope";
} else if (host.includes("games4all")) {
  template = "Games4all";
} else if (host.includes("mobiflix")) {
  template = "Mobiflix";
} else if (host.includes("miximo")) {
  template = "Miximo";
} else if (host.includes("gameknight")) {
  template = "Gameknight";
} else if (host.includes("gameonz")) {
  template = "Gameonz";
} else if (host.includes("funplus")) {
  template = "FunPlus";
} else if (host.includes("gamebox")) {
  template = "GameBox";
} else if (host.includes("fun2win")) {
  template = "Fun2win";
} else if (host.includes("prizeo")) {
  template = "Prizeo";
} else if (host.includes("cutemobi")) {
  template = "Cutemobi";
} else if (host.includes("cutehub")) {
  template = "Cutehub";
} else if (host.includes("apps4all")) {
  template = "Apps4all";
} else if (host.includes("playmix")) {
  template = "Playmix";
} else {
  template = "HelloWorld";
}

const domainLength = 3; // route1.example.com => domain length = 3

function getComp() {
  switch (template) {
    case "Mobiscope":
      document.getElementById("favicon").href = require(`../static/img/icons/mobiscope-favi.jpg`);
      return { component: { Mobiscope }, route: mobiscope, i18n: i18n_Ms };
      break;
    case "Mobizone":
      document.getElementById("favicon").href = require(`../static/img/icons/mobizone-favicon.png`);
      return { component: { Mobizone }, route: mobizone, i18n: i18n_Mz };
      break;
    case "Games4all":
      document.getElementById("favicon").href = require(`../static/img/icons/games4all-favi.png`);
      return { component: { Games4all }, route: games4all, i18n: i18n_G4all };
      break;
    case "Mobiflix":
      document.getElementById("favicon").href = require(`../static/img/icons/mobiflix-favicon.png`);
      return { component: { Mobiflix }, route: mobiflix, i18n: i18n_Mf };
      break;
    case "Miximo":
      document.getElementById("favicon").href = require(`../static/img/icons/miximo-favicon.png`);
      return { component: { Miximo }, route: miximo, i18n: i18n_Mix };
      break;
    case "Gameknight":
      document.getElementById("favicon").href = require(`../static/img/icons/gameknight-favicon.png`);
      return { component: { Gameknight }, route: gameknight, i18n: i18n_Gkn };
      break;
    case "Gameonz":
      document.getElementById("favicon").href = require(`../static/img/icons/gameonz-favicon.png`);
      return { component: { Gameonz }, route: gameonz, i18n: i18n_Gonz };
      break;
    case "FunPlus":
      document.getElementById("favicon").href = require(`../static/img/icons/funplus-favicon.png`);
      return { component: { FunPlus }, route: funplus, i18n: i18n_FunP };
      break;
    case "GameBox":
      document.getElementById("favicon").href = require(`../static/img/icons/gamebox-favicon.png`);
      return { component: { GameBox }, route: gamebox, i18n: i18n_gamebox };
      break;
    case "Prizeo":
      document.getElementById("favicon").href = require(`../static/img/icons/prizeo-favicon.png`);
      return { component: { Prizeo }, route: prizeo, i18n: i18n_prizeo };
      break;
    case "Fun2win":
      document.getElementById("favicon").href = require(`../static/img/icons/fun2win-favicon.png`);
      return { component: { Fun2win }, route: fun2win, i18n: i18n_F2w };
      break;
    case "Cutemobi":
      document.getElementById("favicon").href = require(`../static/img/icons/cutemobi-favicon.png`);
      return { component: { Cutemobi }, route: cutemobi, i18n: i18n_cm };
      break;
    case "Cutehub":
      document.getElementById("favicon").href = require(`../static/img/icons/cutehub-favicon.png`);
      return { component: { Cutehub }, route: cutehub, i18n: i18n_cutehub };
      break;
    case "Apps4all":
      document.getElementById("favicon").href = require(`../static/img/icons/Apps4all-favicon.png`);
      return { component: { Apps4all }, route: apps4all, i18n: i18n_a4all };
      break;
    case "Playmix":
      document.getElementById("favicon").href = require(`../static/img/icons/Playmix-favicon.png`);
      return { component: { Playmix }, route: playmix, i18n: i18n_Pm };
      break;
    default:
      return { component: { HelloWorld }, route: "", i18n: "" };
      break;
  }
}

// next try
// case "Gameonz":
//       return {'component': { Gameonz },'route': gameonz}
//       break;

//change document title
document.title = template;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  i18n: getComp().i18n,
  router: getComp().route,
  template: `<${template}/>`,
  components: getComp().component,
  render: h => h(template)
});



// WEBPACK FOOTER //
// ./src/main.js